<template>
  <div>
    <!-- 支付页面 -->
    <!-- 2023/2/23 大榭说订单优惠券还没有,先不接 -->
    <div class="supportingSurface">
      <div class="balancePayment">
        <!-- 余额界面 -->
        <baseBreadcrumb :page="$t('message.balancePayment')" :menu="$t('message.orderManagement')"></baseBreadcrumb>
        <div class="paymentDetails">
          <!-- 接的时候订单支付没有优惠券,这些参数需要重新接过 -->
          <!-- 订单支付信息 -->
          <template v-if="orderPayType">
            <div>
              <!-- 预计订单金额： -->
              <p>
                {{ $t("message.estimatedOrderAmount") }}：{{
                  orderPayPrevieData.total_amount
                }}日元
              </p>
              <!-- 账户余额 -->
              <p>
                {{ $t("message.accountBalance1") }}(含冻结余额)：{{
                  orderPayPrevieData.user_balance
                }}日元
              </p>
              <!-- 实际支付金额 -->
              <p>
                {{ $t("message.actualAmountPaid") }}：{{
                  orderPayPrevieData.pay_amount_jpy
                }}日元
              </p>
              <!-- 付款后账户剩余 -->
              <p>
                {{ $t("message.accountBalanceAfterPayment") }}：{{
                  orderPayPrevieData.user_balance -
                  orderPayPrevieData.pay_amount_jpy
                }}日元
              </p>
            </div>
          </template>
          <!-- 配送单支付信息 -->
          <template v-else>
            <div>
              <!-- 预计配送单金额： -->
              <p>
                {{ $t("message.estimatedDeliveryOrderAmount") }}：{{
                  orderPayPrevieData.sum_amount_jpy
                }}日元
              </p>
              <!-- 账户余额 -->
              <p>
                {{ $t("message.accountBalance1") }}：{{
                  orderPayPrevieData.user_balance
                }}日元
              </p>
              <!-- 实际支付金额 -->
              <p>
                {{ $t("message.actualAmountPaid") }}：{{
                  orderPayPrevieData.pay_amount_jpy
                }}日元
              </p>
              <!-- 付款后账户剩余 用户余额-实际支付金额 -->
              <p>
                {{ $t("message.accountBalanceAfterPayment") }}：{{
                  orderPayPrevieData.user_balance -
                  orderPayPrevieData.pay_amount_jpy
                }}日元
              </p>
            </div>
          </template>
          <div class="btnBox">
            <!-- 使用优惠券 -->

            <div
              v-if="(orderPayPrevieData.discounts_used_ids == false || orderPayPrevieData.discounts_used_ids == null) && !isPartialPayment">
              <el-checkbox v-model="isUsed" @click.native="openDia">
                {{ $t("message.useOoupons") }}
              </el-checkbox>
              <span class="youHuiwenZi" v-if="preferentialAmount.name">
                已选择:
                <span><b>{{ preferentialAmount.name }}</b> 优惠券</span>
              </span>
              <span class="youHuiwenZi" v-if="preferentialAmount.name">
                抵扣:
                <span><b>{{ orderPayPrevieData.discounts_amount_jpy }}</b> 円</span>
              </span>
            </div>
            <el-button type="success" @click="orderPay">支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <couponsVue ref="couponsVue" />
  </div>
</template>
<script>
import couponsVue from "./components/oupons.vue";
export default {
  data() {
    return {
      datas: {
        order_sn: this.$route.query.order_sn,
        porder_sn: this.$route.query.porder_sn,
        user_id: this.$route.query.userID,
      },
      orderPayPrevieData: {},
      usableDiscountList: [],
      isPartialPayment: false, // 是否为分批付款订单
      isUsed: false, //是否已使用优惠券
      preferentialAmount: {
        name: "",
      }, //优惠金额
    };
  },
  components: {
    couponsVue,
  },
  computed: {
    // 是否是订单支付
    orderPayType() {
      return !!this.$route.query.order_sn;
    },
  },
  created() {
    if (this.datas.order_sn) {
      this.orderPayPreview();
    } else if (this.datas.porder_sn) {
      this.porderPayData();
    }
    this.usableDiscount();
  },
  methods: {
    //打开使用优惠券弹窗
    openDia() {
      this.$refs.couponsVue.open({
        // 点击确定按钮事件
        successMethods: (active) => {
          // 如果使用了优惠券就查找优惠券id
          if (active > -1) {
            this.datas.discounts_id = this.usableDiscountList[active].id;
          } else {
            this.datas.discounts_id = "";
          }
          // 调用相应的获取数据接口
          if (this.orderPayType) {
            this.orderPayPreview();
          } else {
            this.porderPayData();
          }
          this.$refs.couponsVue.show = false;
        },
      });
    },
    // 获取配送单支持使用的优惠券
    usableDiscount() {
      if (this.$route.query.order_sn) {
        this.$api.clienteleApi
          .orderUsableDiscount({
            user_id: this.$route.query.userID,
            order_sn: this.datas.order_sn,
            pageSize: 9999,
            page: 1,
          })
          .then((res) => {
            //接下来的操作
            // this.usableDiscountList = res.data.data;
            this.usableDiscountList = res.data.data;
          });
      } else {
        this.$api.clienteleApi
          .porderUsableDiscount({
            user_id: this.$route.query.userID,
            porder_sn: this.datas.porder_sn,
            pageSize: 9999,
            page: 1,
          })
          .then((res) => {
            //接下来的操作
            // this.usableDiscountList = res.data.data;
            this.usableDiscountList = res.data.data;
          });
      }
    },
    // 获取订单支付预览数据
    orderPayPreview() {
      let dd = JSON.parse(JSON.stringify(this.datas));
      if (this.datas.discounts_id) {
        dd.discounts_id = [dd.discounts_id];
      }
      this.$api.clienteleApi.orderPayPreview(dd).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.isPartialPayment = res.data.type == 2 || !!res.data.part_pay_amount;
        if (res.data.part_pay_amount) {
          this.orderPayPrevieData = res.data.part_pay_amount.JPY;
          this.orderPayPrevieData.user_balance = res.data.user_balance
          this.orderPayPrevieData.discounts_used_ids = res.data.discounts_used_ids
        } else {
          this.orderPayPrevieData = res.data;
        }

      });
    },
    // 获取配送单支付预览数据
    porderPayData() {
      this.$api.clienteleApi.porderPayData(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.orderPayPrevieData = res.data;
      });
    },
    //订单支付
    orderPay() {
      // 分批付款订单不允许携带优惠券
      if (this.isPartialPayment) {
        this.$delete(this.datas, "discounts_id");
      }
      // 调用对应支付接口
      if (this.orderPayType) {
        this.$api.clienteleApi.orderPay(this.datas).then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg);
          //接下来的操作
          this.$router.push({
            name: "/user/orderList",
            query: {
              userID: this.$route.query.userID,
            },
          });
        });
      } else {
        this.$api.clienteleApi.balancePayPorder(this.datas).then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg);
          //接下来的操作
          this.$router.push({
            name: "/user/deliveryOrder",
            query: {
              userID: this.$route.query.userID,
            },
          });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.supportingSurface {
  .balancePayment {
    .paymentDetails {
      font-size: 20px;
      background-color: #f8f8f8;
      padding: 10px;

      p {
        padding: 10px;
      }

      .btnBox {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        >* {
          margin: 0 10px;
        }

        .youHuiwenZi {
          padding: 0 5px;
          font-size: 12px;
          color: #858585;

          b {
            color: red;
          }
        }
      }
    }
  }
}
</style>
